import en from './en.json';
import ru from './ru.json';

var flatten = function flatten(json) {
  var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var prefix = arguments.length > 2 ? arguments[2] : undefined;
  Object.keys(json).forEach(function (key) {
    var resKey = prefix ? "".concat(prefix, ".").concat(key) : key;
    var value = json[key];

    if (typeof value === 'string') {
      result[resKey] = value;
    } else if (typeof value === 'object') {
      flatten(value, result, resKey);
    }
  });
  return result;
};

var dictMap = {
  en: flatten(en),
  ru: flatten(ru)
};
export default (function (lang) {
  var dict = dictMap[lang] || dictMap.en;
  return function (key) {
    var value = dict[key];

    if (value === undefined) {
      console.warn("Locale value \"".concat(key, "\" missing."));
      return '-';
    }

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    value = rest.reduce(function (val, param) {
      return val.replace('%s', param);
    }, value);
    return value.replace(/%s/g, '');
  };
});